import React from 'react';

import { GenreSimplifieDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { GenreSimplifieFormField, GenreSimplifieFormValue } from '../types';
import { buildDefaultUpdateFormValues, buildDto } from '../utils';

import ModalEdition from './ModalEdition';

interface ModalUpdateProps {
  genreSimplifie: GenreSimplifieDto;
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalUpdate({
  genreSimplifie,
  close,
  visible,
  refreshDashboard,
}: ModalUpdateProps): React.ReactElement {
  const idCorrelation = genreSimplifie.idCorrelation;
  const initialValues: GenreSimplifieFormValue =
    buildDefaultUpdateFormValues(genreSimplifie);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: GenreSimplifieFormValue) =>
      AdminFonctionnelControllerApi.updateGenreSimplifieUsingPUT(
        idCorrelation,
        buildDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: GenreSimplifieFormField, values: GenreSimplifieFormValue) =>
      AdminFonctionnelControllerApi.validateUpdateGenreSimplifieFieldUsingPOST(
        field,
        idCorrelation,
        buildDto(values),
      ),
    response => response.genreSimplifieViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Modifier un genre simplifié"
      initials={initialValues}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
